export function hasActiveSubscriptionPlan(plan) {
  if (!plan || plan.Id == null) {
    return false;
  }

  return Number(plan.Id) !== 1;
}
